import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../theme";
import ProgressCircle from "./ProgressCircle";
import Divider from "@mui/material/Divider";

const AnyBox1 = ({ name = "", CL = "" }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box width="80%" m="0 20px">
      <Box display="flex" justifyContent="start" mt="20px">
        <Typography
          variant="h4"
          fontWeight="bold"
          sx={{ color: colors.grey[100] }}
        >
          {name}
        </Typography>
      </Box>
      <Divider sx={{ mt: "9px" }} />
      <Box display="flex" justifyContent="space-around" mt="50px">
        <Box>
          <Typography
            variant="h5"
            fontWeight="bold"
            sx={{ color: colors.greenAccent[300] }}
          >
            Chlorine value
          </Typography>
          <Typography
            mt="15px"
            variant="h3"
            fontWeight="bold"
            sx={{ color: colors.grey[100], ml: "44px" }}
          >
            {CL}
          </Typography>
        </Box>
      </Box>

    </Box>
  );
};

export default AnyBox1;
